import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	dismissTopicSuccessTitle: {
		id: 'servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-success-title',
		defaultMessage: 'Removed the suggested topic',
		description: 'The title text of the success flag for removing a topic.',
	},
	dismissTopicErrorTitle: {
		id: 'servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-title',
		defaultMessage: 'We couldn’t remove the topic',
		description: 'There was an API failure and the action couldn’t be completed.',
	},
	dismissTopicErrorDescription: {
		id: 'servicedesk-knowledge-hub-topics.controllers.store.actions.dismiss-topic.dismiss-topic-error-description',
		defaultMessage: 'Something went wrong. Try again or refresh the page',
		description: 'There was an API failure and the action couldn’t be completed.',
	},
});
